module.exports = __webpack_public_path__ + "img/square-lined.4bf2ae78.svg";